/*
 * BRIORA P33 (handoff 2.82) · Favoritos sin app. Ampliado en la P35 (handoff 2.85).
 * - Guarda los handles de las piezas en localStorage ("brioraFavoritos", 60 como máximo, la última primero).
 * - Pone un corazón en cada tarjeta de producto (dentro de .card-gallery) y en las de «Vistos recientemente»,
 *   y un botón «Guardar en favoritos» en la ficha, debajo de los botones de compra (body[data-bm-handle], lo pone
 *   layout/theme.liquid; no en tarjetas regalo).
 * - Actualiza el contador del icono de la cabecera (snippets/header-actions.liquid, [data-bm-fav-count]).
 * - La primera vez que alguien guarda una pieza sale un aviso «Guardada en favoritos · Ver favoritos»
 *   (localStorage "brioraFavoritosAviso"; una sola vez por navegador).
 * - Pinta la página /pages/favoritos (sections/briora-favoritos.liquid) pidiendo /products/<handle>.js; las piezas
 *   que ya no existen (404) se quitan de la lista. En esa página:
 *   - «Compartir la lista»: menú nativo del móvil (navigator.share) o, si no hay, WhatsApp y «Copiar enlace».
 *     El enlace es /pages/favoritos?lista=handle1,handle2… y solo lleva handles.
 *   - Con ?lista= se ve la lista compartida (solo lectura): cada pieza con su corazón y «Guardar todas».
 *     No toca la lista propia hasta que la persona guarda algo.
 *   - «Pregúntanos por estas piezas»: WhatsApp de la tienda con la lista escrita (nombre, precio y enlace).
 *   - «Vistos recientemente»: los vistos de la ficha ("brioraViewed", IDs) pedidos a la búsqueda con
 *     section_id=briora-recently-viewed, sin los que ya están en la lista; también cuando está vacía.
 * El clic en los corazones se escucha en captura y se detiene: la tarjeta entera es un enlace y tiene su transición.
 */
(function () {
  'use strict';

  var KEY = 'brioraFavoritos';
  var KEY_NOTICE = 'brioraFavoritosAviso';
  var KEY_VIEWED = 'brioraViewed';
  var MAX = 60;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var HEART_PATH = 'M12 20.4s-8.4-5.1-10.1-10.3C.7 6.4 3.1 2.6 6.9 2.6c2.2 0 3.8 1.2 5.1 3 1.3-1.8 2.9-3 5.1-3 3.8 0 6.2 3.8 5 7.5C20.4 15.3 12 20.4 12 20.4Z';
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/;

  function cleanList(list) {
    if (!Array.isArray(list)) return [];
    var seen = {};
    return list.filter(function (h) {
      if (typeof h !== 'string' || !HANDLE_RE.test(h) || seen[h]) return false;
      seen[h] = true;
      return true;
    }).slice(0, MAX);
  }

  function read() {
    try { return cleanList(JSON.parse(window.localStorage.getItem(KEY) || '[]')); } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(cleanList(list))); } catch (e) {}
    sync();
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i !== -1) { list.splice(i, 1); write(list); }
  }

  function addMany(handles) {
    var list = read();
    handles.slice().reverse().forEach(function (h) { if (list.indexOf(h) === -1) list.unshift(h); });
    write(list);
  }

  function handleFrom(href) {
    var m = /\/products\/([a-z0-9][a-z0-9-]*)/.exec(href || '');
    return m ? m[1] : null;
  }

  function heartIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 22');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '18');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', HEART_PATH);
    svg.appendChild(path);
    return svg;
  }

  function makeButton(handle, title, kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bm-fav bm-fav--' + kind;
    b.setAttribute('data-bm-fav', handle);
    b.setAttribute('data-bm-fav-title', title || '');
    b.setAttribute('aria-pressed', 'false');
    b.appendChild(heartIcon());
    if (kind === 'ficha') {
      var t = document.createElement('span');
      t.className = 'bm-fav__text';
      b.appendChild(t);
    }
    return b;
  }

  function decorateCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-bm-fav]')) continue;
      var link = card.querySelector('a.product-card__link');
      var handle = handleFrom(link && link.getAttribute('href'));
      var gallery = card.querySelector('.card-gallery');
      if (!handle || !gallery) continue;
      gallery.appendChild(makeButton(handle, link.getAttribute('aria-label') || '', 'card'));
    }
    // «Vistos recientemente» (ficha y página de favoritos): el corazón va en el <li>, fuera del enlace.
    var recent = scope.querySelectorAll('.briora-recent__item');
    for (var j = 0; j < recent.length; j++) {
      var item = recent[j];
      if (item.querySelector('[data-bm-fav]')) continue;
      var a = item.querySelector('a.briora-recent__link');
      var h = handleFrom(a && a.getAttribute('href'));
      if (!h) continue;
      var name = item.querySelector('.briora-recent__name');
      item.classList.add('bm-fav-host');
      item.appendChild(makeButton(h, name ? name.textContent.trim() : '', 'card'));
    }
  }

  function decorateProduct() {
    var handle = document.body && document.body.getAttribute('data-bm-handle');
    if (!handle || document.querySelector('.bm-fav--ficha')) return;
    var details = document.querySelector('.product-details');
    if (!details) return;
    var titleEl = details.querySelector('.briora-product-title, h1');
    var anchor = details.querySelector('.buy-buttons-block') || titleEl;
    if (!anchor) return;
    var b = makeButton(handle, titleEl ? titleEl.textContent.trim() : '', 'ficha');
    anchor.insertAdjacentElement('afterend', b);
  }

  function sync() {
    var list = read();
    var buttons = document.querySelectorAll('[data-bm-fav]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-bm-fav')) !== -1;
      var title = b.getAttribute('data-bm-fav-title');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      if (b.classList.contains('bm-fav--ficha')) {
        var t = b.querySelector('.bm-fav__text');
        if (t) t.textContent = on ? 'Guardada en favoritos' : 'Guardar en favoritos';
      } else if (b.classList.contains('bm-fav--item')) {
        var it = b.querySelector('.bm-fav__text');
        if (it) it.textContent = on ? 'Guardada' : 'Guardar';
        b.setAttribute('aria-label', (on ? 'Quitar de mis favoritos: ' : 'Guardar en mis favoritos: ') + title);
      } else {
        b.setAttribute('aria-label', (on ? 'Quitar de favoritos: ' : 'Guardar en favoritos: ') + title);
      }
    }
    var counts = document.querySelectorAll('[data-bm-fav-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = list.length ? String(list.length) : '';
      counts[j].hidden = !list.length;
    }
    var headers = document.querySelectorAll('[data-bm-fav-header]');
    for (var k = 0; k < headers.length; k++) {
      headers[k].setAttribute('aria-label', list.length ? 'Favoritos (' + list.length + ')' : 'Favoritos');
    }
  }

  function announce(text) {
    var live = document.getElementById('bm-fav-live');
    if (!live) {
      live = document.createElement('p');
      live.id = 'bm-fav-live';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 30);
  }

  /* Aviso de la primera vez */

  function seenNotice() {
    try { return window.localStorage.getItem(KEY_NOTICE) === '1'; } catch (e) { return true; }
  }

  function firstSaveNotice() {
    if (seenNotice() || document.querySelector('[data-bm-favoritos]')) return;
    try { window.localStorage.setItem(KEY_NOTICE, '1'); } catch (e) { return; }
    var box = el('div', 'bm-fav-toast');
    box.setAttribute('role', 'status');
    box.appendChild(heartIcon());
    box.appendChild(el('span', 'bm-fav-toast__text', 'Guardada en favoritos'));
    var link = el('a', 'bm-fav-toast__link', 'Ver favoritos');
    link.href = ROOT + 'pages/favoritos';
    box.appendChild(link);
    var close = el('button', 'bm-fav-toast__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Cerrar aviso');
    box.appendChild(close);
    document.body.appendChild(box);
    var hide = function () {
      box.classList.remove('is-visible');
      window.setTimeout(function () { box.remove(); }, 400);
    };
    close.addEventListener('click', hide);
    window.requestAnimationFrame(function () { box.classList.add('is-visible'); });
    var timer = window.setTimeout(hide, 7000);
    box.addEventListener('mouseenter', function () { window.clearTimeout(timer); });
    box.addEventListener('focusin', function () { window.clearTimeout(timer); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bm-fav]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-bm-fav'));
    b.classList.remove('is-pulse');
    void b.offsetWidth;
    if (on) b.classList.add('is-pulse');
    announce(on ? 'Guardada en favoritos.' : 'Quitada de favoritos.');
    if (on) firstSaveNotice();
    if (!b.classList.contains('bm-fav--item')) renderPage();
  }, true);

  /* Página de favoritos */

  function money(cents, format) {
    var fixed = (Number(cents || 0) / 100).toFixed(2).split('.');
    var dots = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var commas = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = format || '€{{amount_with_comma_separator}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dots + ',' + fixed[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, commas)
      .replace(/\{\{\s*amount\s*\}\}/, commas + '.' + fixed[1]);
  }

  function priceText(p, format) {
    if ((p.tags || []).indexOf('a-medida') !== -1) return 'Precio a consultar';
    if (p.price_varies) return 'Desde ' + money(p.price_min, format);
    return money(p.price, format);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) return { missing: true };
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .catch(function () { delete cache[handle]; return null; });
    return cache[handle];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function card(p, format, shared) {
    var li = el('li', 'bm-favs__item');
    // P36 (handoff 2.86): marca de la pieza, como en snippets/product-card.liquid (fondo y letra en briora-marcas.css).
    li.setAttribute('data-brand', /FINO/.test(p.vendor || '') ? 'fino' : 'briora');
    var a = el('a', 'bm-favs__link');
    a.href = ROOT + 'products/' + p.handle;
    var media = el('span', 'bm-favs__media');
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imageUrl(p.featured_image, 600);
      img.srcset = imageUrl(p.featured_image, 360) + ' 360w, ' + imageUrl(p.featured_image, 600) + ' 600w, ' + imageUrl(p.featured_image, 900) + ' 900w';
      img.sizes = '(min-width: 990px) 22vw, (min-width: 600px) 30vw, 46vw';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 600;
      img.height = 600;
      media.appendChild(img);
    }
    a.appendChild(media);
    if (p.vendor) a.appendChild(el('span', 'bm-favs__brand', p.vendor));
    a.appendChild(el('span', 'bm-favs__name', p.title));
    var medida = (p.tags || []).indexOf('a-medida') !== -1;
    a.appendChild(el('span', 'bm-favs__price', priceText(p, format)));
    if (!p.available && !medida) a.appendChild(el('span', 'bm-favs__soldout', 'Agotada'));
    li.appendChild(a);
    if (shared) {
      var save = makeButton(p.handle, p.title, 'item');
      var label = el('span', 'bm-fav__text', 'Guardar');
      save.appendChild(label);
      li.appendChild(save);
    } else {
      var rm = el('button', 'bm-favs__remove', 'Quitar');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Quitar de favoritos: ' + p.title);
      rm.addEventListener('click', function () {
        remove(p.handle);
        announce('Quitada de favoritos.');
        renderPage();
      });
      li.appendChild(rm);
    }
    return li;
  }

  function sharedHandles() {
    var raw = new URLSearchParams(window.location.search).get('lista');
    if (raw == null) return null;
    return cleanList(raw.split(',').map(function (h) { return h.trim().toLowerCase(); }));
  }

  function shareUrl(handles) {
    return window.location.origin + ROOT + 'pages/favoritos?lista=' + handles.join(',');
  }

  function whatsappText(root, items) {
    var format = root.getAttribute('data-money-format');
    var lines = items.map(function (p) {
      return '• ' + p.title + ' (' + priceText(p, format) + ')\n' + window.location.origin + ROOT + 'products/' + p.handle;
    });
    return (root.getAttribute('data-ask-intro') || 'Hola, me gustaría que me asesorarais sobre estas piezas:') + '\n\n' + lines.join('\n\n');
  }

  function setupActions(root, items, shared, handles) {
    var bar = root.querySelector('[data-bm-favs-actions]');
    if (!bar) return;
    bar.textContent = '';
    bar.hidden = !items.length;
    if (!items.length) return;

    if (shared) {
      var all = el('button', 'bm-favs__btn bm-favs__btn--dark', 'Guardar todas en mis favoritos');
      all.type = 'button';
      all.addEventListener('click', function () {
        addMany(items.map(function (p) { return p.handle; }));
        announce('Guardadas en tus favoritos.');
        all.textContent = 'Guardadas en tus favoritos';
      });
      bar.appendChild(all);
      var mine = el('a', 'bm-favs__btn', 'Ver mis favoritos');
      mine.href = ROOT + 'pages/favoritos';
      bar.appendChild(mine);
    } else {
      var url = shareUrl(handles);
      var shareText = root.getAttribute('data-share-text') || 'Mis joyas favoritas de BRIORA';
      var share = el('button', 'bm-favs__btn bm-favs__btn--dark', 'Compartir la lista');
      share.type = 'button';
      share.setAttribute('aria-expanded', 'false');
      var options = el('div', 'bm-favs__share');
      options.hidden = true;
      var wa = el('a', 'bm-favs__share-link', 'WhatsApp');
      wa.href = 'https://wa.me/?text=' + encodeURIComponent(shareText + ': ' + url);
      wa.target = '_blank';
      wa.rel = 'noopener';
      var copy = el('button', 'bm-favs__share-link', 'Copiar enlace');
      copy.type = 'button';
      copy.addEventListener('click', function () {
        var done = function () { copy.textContent = 'Enlace copiado'; announce('Enlace copiado.'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copia el enlace:', url); });
        } else {
          window.prompt('Copia el enlace:', url);
        }
      });
      options.appendChild(wa);
      options.appendChild(copy);
      share.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: shareText, text: shareText, url: url }).catch(function () {});
          return;
        }
        options.hidden = !options.hidden;
        share.setAttribute('aria-expanded', options.hidden ? 'false' : 'true');
      });
      bar.appendChild(share);
      bar.appendChild(options);
    }

    var phone = (root.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
    if (phone) {
      var ask = el('a', 'bm-favs__btn', root.getAttribute('data-ask-label') || 'Pregúntanos por estas piezas');
      ask.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(whatsappText(root, items));
      ask.target = '_blank';
      ask.rel = 'noopener';
      bar.appendChild(ask);
    }
  }

  function setHead(root, shared) {
    var map = [['eyebrow', '[data-bm-favs-eyebrow]'], ['heading', '[data-bm-favs-heading]'], ['text', '[data-bm-favs-text]']];
    map.forEach(function (m) {
      var node = root.querySelector(m[1]);
      if (!node) return;
      if (!node.hasAttribute('data-own')) node.setAttribute('data-own', node.innerHTML);
      if (shared) node.textContent = root.getAttribute('data-shared-' + m[0]) || node.textContent;
      else node.innerHTML = node.getAttribute('data-own');
    });
  }

  var renderToken = 0;
  function renderPage() {
    var root = document.querySelector('[data-bm-favoritos]');
    if (!root) return;
    var listEl = root.querySelector('[data-bm-favs-list]');
    var empty = root.querySelector('[data-bm-favs-empty]');
    var countEl = root.querySelector('[data-bm-favs-count]');
    var format = root.getAttribute('data-money-format');
    var fromLink = sharedHandles();
    var shared = fromLink !== null;
    var handles = shared ? fromLink : read();
    var token = ++renderToken;
    setHead(root, shared);
    root.toggleAttribute('data-shared', shared);
    root.removeAttribute('data-loading');
    if (!handles.length) {
      listEl.textContent = '';
      empty.hidden = false;
      if (countEl) countEl.textContent = '';
      setupActions(root, [], shared, handles);
      renderRecent(root, []);
      return;
    }
    empty.hidden = true;
    root.setAttribute('data-loading', '');
    Promise.all(handles.map(fetchProduct)).then(function (items) {
      if (token !== renderToken) return;
      var missing = [];
      var ok = [];
      var frag = document.createDocumentFragment();
      items.forEach(function (p, i) {
        if (!p) return;
        if (p.missing) { missing.push(handles[i]); return; }
        ok.push(p);
        frag.appendChild(card(p, format, shared));
      });
      if (missing.length && !shared) {
        write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
      listEl.textContent = '';
      listEl.appendChild(frag);
      var n = ok.length;
      if (countEl) countEl.textContent = n === 1 ? '1 pieza' + (shared ? '' : ' guardada') : n + ' piezas' + (shared ? '' : ' guardadas');
      empty.hidden = n > 0;
      root.removeAttribute('data-loading');
      setupActions(root, ok, shared, ok.map(function (p) { return p.handle; }));
      sync();
      renderRecent(root, ok.map(function (p) { return p.handle; }));
    });
  }

  /* Vistos recientemente en la página de favoritos */

  var recentToken = 0;
  function renderRecent(root, exclude) {
    var box = root.querySelector('[data-bm-favs-recent]');
    if (!box) return;
    var ids = [];
    try { ids = JSON.parse(window.localStorage.getItem(KEY_VIEWED) || '[]'); } catch (e) { ids = []; }
    if (!Array.isArray(ids)) ids = [];
    ids = ids.filter(function (id) { return /^\d+$/.test(String(id)); }).slice(0, 9);
    var token = ++recentToken;
    if (!ids.length) { box.hidden = true; return; }
    var url = new URL(ROOT + 'search', window.location.origin);
    url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', 'briora-recently-viewed');
    fetch(url.toString())
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (token !== recentToken) return;
        var list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-briora-recent-results]');
        if (!list) { box.hidden = true; return; }
        var items = Array.prototype.slice.call(list.children).filter(function (li) {
          var a = li.querySelector('a.briora-recent__link');
          return exclude.indexOf(handleFrom(a && a.getAttribute('href'))) === -1;
        }).sort(function (a, b) {
          return ids.indexOf(String(a.getAttribute('data-product-id'))) - ids.indexOf(String(b.getAttribute('data-product-id')));
        }).slice(0, 8);
        if (!items.length) { box.hidden = true; return; }
        list.textContent = '';
        items.forEach(function (li) { list.appendChild(li); });
        var target = box.querySelector('[data-bm-favs-recent-target]');
        target.textContent = '';
        target.appendChild(document.importNode(list, true));
        box.hidden = false;
        decorateCards(box);
        sync();
      })
      .catch(function () {});
  }

  function run() {
    decorateCards(document);
    decorateProduct();
    sync();
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; run(); });
  }

  function init() {
    run();
    renderPage();
    if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { sync(); if (sharedHandles() === null) renderPage(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { sync(); renderPage(); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
